"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _propTypes = require("../../prop-types");

var _responsive = require("../../responsive");

var _constants = require("./constants");

var _DropdownSelect = _interopRequireDefault(require("./dropdown/DropdownSelect"));

var _interfaces = require("./interfaces");

var _native = require("./native");

var _utils = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["layout", "value", "defaultValue", "onChange"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SelectWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, externalRef) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? _constants.defaultProps.layout : _ref$layout,
      propValue = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useBreakpoints = (0, _responsive.useBreakpoints)(),
      matches = _useBreakpoints.matches;

  var useNative = (0, _utils.shouldUseNativeSelect)(layout, matches, {
    isSearchable: forwardedProps.isSearchable,
    isMulti: forwardedProps.isMulti,
    isExperimentalLayout: !!forwardedProps.experimentalLayoutProps
  });

  var _useState = (0, _react.useState)((0, _utils.getDefaultValue)({
    isMulti: forwardedProps.isMulti,
    primaryValue: propValue,
    otherValue: defaultValue
  })),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var value = (0, _utils.getDefaultValue)({
    isMulti: forwardedProps.isMulti,
    primaryValue: propValue,
    otherValue: stateValue
  });
  var handleChange = (0, _react.useCallback)(function (newValue) {
    setStateValue(newValue);
    !!onChange && onChange(newValue);
  }, [onChange]);
  var sharedProps = {
    value: value,
    onChange: handleChange
  };

  if (useNative) {
    return (0, _core.jsx)(_native.NativeSelect, (0, _extends2.default)({}, forwardedProps, sharedProps, {
      ref: externalRef
    }));
  } else {
    return (0, _core.jsx)(_DropdownSelect.default, (0, _extends2.default)({}, forwardedProps, sharedProps, {
      ref: externalRef
    }));
  }
});
var Select = (0, _stencilReactDesc.describe)(SelectWithoutDocs).description('Form element for choosing from a list of options.');
Select.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _propTypes.statusPropTypes), _propTypes.widthPropTypes), {}, {
  options: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.any).isRequired.description('Array of options to display in the list for users to choose from.'),
  customSelectionOptions: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.shape({
    checked: _stencilReactDesc.PropTypes.bool,
    label: _stencilReactDesc.PropTypes.string.isRequired,
    onClick: _stencilReactDesc.PropTypes.func.isRequired
  })).description('Array of custom selection options to display above regular options with custom onClick. Only applies when isMulti is also set.'),
  customSelectionOptionsLabel: _stencilReactDesc.PropTypes.string.description('Text to display on top of custom selection options in the dropdown list. Only applies when custom selection options available.'),
  defaultOptionsLabel: _stencilReactDesc.PropTypes.string.description('Text to display on top of regular options in the dropdown list. Only applies when custom selection options available.'),
  disabledTagsHiddenText: _stencilReactDesc.PropTypes.string.description('Hidden text providing description why selection tags are not dismissible in a disabled multi select.'),
  valueAccessor: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.func]).description('Function or string which is used to retrieve unique string for representation from object type value. It is also used to create labels for native select if renderNativeOption is not provided.').format('string | (option: any) => string'),
  renderOption: _stencilReactDesc.PropTypes.func.description('Render function used to render each option in the dropdown list. Does not apply to the native select.').format('(option: any, dropdownOptionProps: DropdownOptionProps) => React.ReactNode'),
  renderNativeOption: _stencilReactDesc.PropTypes.func.description('Render function used to render each option in the dropdown list for native select.').format('(option: any) => string'),
  renderSelectedValue: _stencilReactDesc.PropTypes.func.description('Render function used to render the selected value in the trigger button and in the tags in multi select mode. Does not apply to the native select.').format('(option: any) => React.ReactNode'),
  onChange: _stencilReactDesc.PropTypes.func.description('Callback called when the selected value changes.').format('(newValue: any) => void'),
  value: _stencilReactDesc.PropTypes.any.description("The currently selected option, used when the component is being controlled. This should be one of the options from the 'options' array."),
  defaultValue: _stencilReactDesc.PropTypes.any.description("The initially selected option, used when the component is not controlled. This should be one of the options from the 'options' array."),
  id: _stencilReactDesc.PropTypes.string.description("Sets the 'id' attribute for the form element."),
  name: _stencilReactDesc.PropTypes.string.description("Sets the 'name' attribute for the form element."),
  labelId: _stencilReactDesc.PropTypes.string.description('The id of the label for this element. Used to connect the label with the dropdown for assistive technologies.'),
  placeholder: _stencilReactDesc.PropTypes.string.description('Text to display in the select when no option has been selected.'),
  selectedOptionAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the checkmark icon on the selected option in the dropdown. Does not apply to the native select.'),
  selectedOptionDismissAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the X button in the selected option tag when isMulti prop is enabled. Does not apply to the native select.'),
  searchFieldAriaLabel: _stencilReactDesc.PropTypes.string.description("Sets the 'aria-label' of the inset search field when isSearchable is true."),
  layout: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.SelectLayout)).description('Sets the layout of the component from a predefined set.'),
  isSearchable: _stencilReactDesc.PropTypes.bool.description('Determines whether to display the search field to filter out options.'),
  isMulti: _stencilReactDesc.PropTypes.bool.description('Determines whether selecting multiple options is allowed.'),
  noOptionsText: _stencilReactDesc.PropTypes.string.description('Text to display when there are no options.'),
  getTriggerText: _stencilReactDesc.PropTypes.func.description('Function used to return text for the trigger when multiple items are selected.').format('(numberOfSelectedItems: number) => string'),
  filterOptions: _stencilReactDesc.PropTypes.func.description('Function used to filter the results when search is used.').format('(query: string) => Option[]'),
  listMaxHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'max-height' property for the dropdown list. Does not apply to the native select."),
  virtualizedListProps: _stencilReactDesc.PropTypes.shape({
    itemHeight: _stencilReactDesc.PropTypes.number,
    visibleItems: _stencilReactDesc.PropTypes.number
  }).description('Allows enabling and controlling virtualized list feature to solve performance issues when using large datasets.'),
  experimentalLayoutProps: _stencilReactDesc.PropTypes.shape({
    labelText: _stencilReactDesc.PropTypes.string,
    triggerButtonProps: _stencilReactDesc.PropTypes.object,
    popoverControllerProps: _stencilReactDesc.PropTypes.object
  }).description('Experimental layout with the list in popover and customizable trigger button.'),
  dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes."),
  listPositioningStrategy: _stencilReactDesc.PropTypes.oneOf(['absolute', 'fixed']).description('Defines the strategy for the dropdown list placement.'),
  'aria-required': _stencilReactDesc.PropTypes.bool.description('Indicates to assistive technologies that the field is required to submit the form.'),
  'aria-describedby': _stencilReactDesc.PropTypes.string.description('The id of another element on the page which describes this element.'),
  'aria-invalid': _stencilReactDesc.PropTypes.bool.description('Indicates to assistive technologies that the current value of the field is not a valid selection.')
});
Select.defaultProps = _objectSpread({}, _constants.defaultProps);
Select.displayName = 'Select';
var _default = Select;
exports.default = _default;